import { Controller } from "@hotwired/stimulus"

// 1-to-10 picker for the post-live rating form. Clicking a number sets
// the hidden `score` input + toggles the `is-selected` class. The submit
// button stays disabled until a score is picked.
export default class extends Controller {
  static targets = ["btn", "scoreInput", "submit"]

  pick(event) {
    const score = parseInt(event.currentTarget.dataset.score, 10)
    if (!score) return
    this.scoreInputTarget.value = String(score)
    this.btnTargets.forEach(b => {
      b.classList.toggle("is-selected", parseInt(b.dataset.score, 10) === score)
    })
    if (this.hasSubmitTarget) this.submitTarget.disabled = false
  }
}
